<template>
    <div>
        <!-- Home Section -->
        <section id="home">
            <section id="xslider" class="contain">
                <div class="txp-banner">
                    <img src="/assets/images/banner1.jpg?v=11" alt="slidebg1" data-bgfit="cover"
                        data-bgposition="left top" data-bgrepeat="no-repeat" style=" width: 100%;">
                </div>
            </section>
        </section>

        <section id="bus" class="contain ">
            <div class="inner">
                <div class="header margin-10px-bottom">
                    <span>Bus Schedule</span>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered text-center">
                        <thead>
                            <tr class="bg-light-gray">
                                <th class="text-uppercase">Time</th>
                                <th class="text-uppercase">Address Dubai Marina Hotel</th>
                                <th class="text-uppercase">Vida Dubai Marina & Yacht Club</th>
                                <th class="text-uppercase">Address Beach Resort</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- loop -->
                            <tr>
                                <td>
                                    07:00
                                </td>
                                <td>
                                    <!-- active icon-->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>

                                </td>
                                <td>
                                    <!-- inactive icon-->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                            <!--loop -->
                            <tr>
                                <td class="align-middle">07:00</td>
                                <td>
                                    <!-- active -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>

                                </td>
                                <td>
                                    <!-- inactive -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                            <tr>
                                <td class="align-middle">07:00</td>
                                <td>
                                    <!-- active -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <!-- inactive -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                            <tr>
                                <td class="align-middle">07:00</td>
                                <td>
                                    <!-- active -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>

                                </td>
                                <td>
                                    <!-- inactive -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                            <tr>
                                <td class="align-middle">07:00</td>
                                <td>
                                    <!-- active -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>

                                </td>
                                <td>
                                    <!-- inactive -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                            <tr>
                                <td class="align-middle">07:00</td>
                                <td>
                                    <!-- active -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="18" fill="#949300"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <!-- inactive -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#124734"></circle>
                                    </svg>
                                </td>
                                <td>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
                                        <circle cx="18" cy="18" r="17.5" stroke="#949300"></circle>
                                    </svg>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- End inner div -->
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        baseUrl: window.location.origin,
    }),
}
</script>

<style></style>